import React from "react";
import styled from "styled-components";
import tw from "twin.macro";

const FloatingButton = styled.a`
  ${tw`fixed z-50`}
  bottom: 32px;
  right: 32px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #212221;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    background-color: #4b4d4b;
    transform: scale(1.1);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  }

  svg {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 640px) {
    width: 50px;
    height: 50px;
    bottom: 16px;
    right: 16px;

    svg {
      width: 26px;
      height: 26px;
    }
  }
`;

const WhatsAppSVG = () => (
  <svg viewBox="0 0 32 32" width="24" height="24">
    <path
      fill="#25D366"
      d="M16 .4C7.4.4.4 7.4.4 16c0 2.8.7 5.5 2.1 7.9L.2 31.8l8.1-2.1c2.3 1.2 4.9 1.8 7.7 1.8 8.6 0 15.6-7 15.6-15.6S24.6.4 16 .4zm0 28.6c-2.4 0-4.7-.6-6.7-1.7l-.5-.3-4.8 1.3 1.3-4.7-.3-.5C3.9 21 3.2 18.6 3.2 16 3.2 8.9 8.9 3.2 16 3.2S28.8 8.9 28.8 16 23.1 29 16 29zm7.3-9.8c-.4-.2-2.3-1.1-2.7-1.2-.4-.2-.7-.2-1 .2-.3.4-1.1 1.2-1.4 1.5-.3.3-.5.3-.9.1-.4-.2-1.7-.6-3.2-2-1.2-1.1-2-2.4-2.2-2.8-.2-.4 0-.6.2-.8.2-.2.4-.5.6-.7.2-.2.3-.4.5-.7.2-.3.1-.5 0-.7-.1-.2-1-2.5-1.4-3.4-.3-.8-.7-.7-1-.7h-.9c-.3 0-.7.1-1 .5-.3.4-1.4 1.3-1.4 3.1 0 1.8 1.4 3.6 1.6 3.9.2.3 2.8 4.3 6.9 6 .9.4 1.6.6 2.2.8.9.3 1.7.3 2.3.2.7-.1 2.3-.9 2.6-1.8.3-.9.3-1.6.2-1.8-.1-.2-.3-.3-.7-.5z"
    />
  </svg>
);

export default function FloatingWhatsApp() {
  const whatsappLink = "https://wa.me/14163212212?text=Hi%20Juis%20Cakes%20%26%20Treats,%20I%20would%20like%20to%20know%20more%20about%20your%20products";

  return (
    <FloatingButton
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      title="Chat with us on WhatsApp"
    >
      <WhatsAppSVG />
    </FloatingButton>
  );
}
